<template>
  <div>
    <van-popup
      v-model="popupShow"
      round
      position="bottom"
    >
      <div class="index-index-prefer">
        <div class="index-prefer-header">
          <div>查看优惠券</div>
          <img
            class="close"
            @click="onPreferShow"
            src="https://img.chinabeego.com/uploadfile/2023/3/1/66.10200239983332.png"
          />
        </div>
        <div class="index-prefer-list">
          <div class="bottom-count">
            <!-- 已过期/已使用/已退款 -->
            <div class="count-left">已使用张数：{{couponMessage.disabledNum}}</div>
            <div class="count-right">可使用:<span :style="'padding: 0 10px;'">{{couponMessage.availableNum}}</span>张</div>
          </div>
          <div :class="['coupon','coupon'+couponMessage.couponType]">
            <div class="top">
              <div class="wei">
                <div class="lef">
                  <div class="sha">
                    <span :class="['s1','iconurl'+couponMessage.couponType]">{{CouponTypeNames[couponMessage.couponType]}}</span>
                    <span class="name">{{ couponMessage.couponName }}</span>
                  </div>
                  <div class="szhon" v-if="couponUseChannel">券码: {{ couponMessage.couponCode }}</div>
                  <div class="szhon" v-if="couponMessage.stackableUse">
                    <template v-if="couponMessage.stackableCount == -1">单笔订单可叠加使用</template>
                    <template v-else>单笔订单可叠加{{ couponMessage.stackableCount }}张</template>
                  </div>
                  <div class="btom">
                    <!-- <div class="szhon">{{ couponMessage.useTime }}</div> -->
                    <div class="xia">
                      <div class="text1">适用范围：</div>  
                      <div class="text2">{{ couponMessage.$limitask }}</div>
                    </div>
                  </div>
                </div>
                <div class="rig">
                  <!-- <template v-if="couponMessage.availableNum && couponMessage.disabledNum"> -->
                    <div class="sha">
                      <div class="inc jio">x{{couponMessage.availableNum +couponMessage.disabledNum}}张</div>
                    </div>
                  <!-- </template> -->
                  <!-- 样式效果 -->
                  <!-- <template v-else>
                    <div class="shatd"></div>
                  </template> -->
                  <div class="xia">
                    <div class="zhen">
                      <div class="zhon" v-if="couponMessage.$useChannelName">{{couponMessage.$useChannelName}}</div>
                      <div class="div1 rich-price" v-price="couponMessage.couponValue"></div>
                      <div v-if="couponMessage.minimumAmount" class="div2">满{{ couponMessage.minimumAmount }}元使用</div>
                      <!-- <template v-if="couponUseChannel">
                        <div class="div3 jio" @click="onJumpToQrCodeDetail(couponMessage.couponId)">
                          <div class="btn"><img class="imgqc" src="https://img.chinabeego.com/uploadfile/2023/5/16/16842037202831938195866277209.png"/>二维码兑换</div>
                        </div>
                      </template> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="foot-time-bar">
            <div v-if="couponMessage.timeLimitDesc">
                {{ couponMessage.useTime }} {{couponMessage.timeLimitDesc}}
            </div>
            <div v-else>{{ couponMessage.useTime }}</div>
            <img v-if="couponMessage.availableNum +couponMessage.disabledNum > 1" src="https://img.chinabeego.com/uploadfile/2023/6/27/16878561032695417696206289533.png"  class="more-img"/>
          </div>
        </div>
        <template v-if="couponMessage.availableNum && couponMessage.disabledNum">
          <div class="bottom-one"></div>
          <div class="bottom-two"></div>
        </template>
        <template v-else>
          <!-- 样式展示 -->
          <div class="bottom-kong"></div>
        </template>
      </div>
    </van-popup>
    <copons ref="copons"></copons>
  </div>
</template>
<script>
import copons from '@/views/coupon/components/coupons'
import {
  CouponTypeEnum,
  CouponStatusEnum,
  CouponTypeNames,
  GoodsTypeNames,
  ExclusiveNames,
  ButtonNames,
  payTypeName,
  offlineJoinRangeTypeName,
  joinRangeTypeName,
  joinGoodsName,
  joinSeckillGoodsTypeName,
  useChannelName
} from '@/views/coupon/utils/enum'
export default {
  props: {
    data:{
      type :String
    }
  },
  data() {
    return {
      CouponTypeNames,
      popupShow: false,
      boxButton: false,
      couponMessage:{},
      couponItem:{},
      isUser:false,

      
      couponUseChannel:'',

    };    
  },
  methods: {
    onPreferShow(data) {
      this.popupShow = !this.popupShow;
      if(data.couponMessage){
        let result = JSON.parse(JSON.stringify(data.couponMessage))||{};
        let item = JSON.parse(JSON.stringify(data.couponMessage.appSubOrderItemDetailVoList[0].couponCodeVo))

        function normalizeLimitDesc(item){
          let desc = '';
            if([2].includes(item.couponType)){
                let temp = item.joinRangeType+''+item.joinGoodsType+''
                desc = joinGoodsName[temp]
            }else if([3].includes(item.couponType)){
                desc = '指定店铺可用（仅限商城商品）';
            }else if([].includes(item.couponType)){
                //活动券
                desc = '指定商品可用'
            }else if([1].includes(item.couponType)){
                if([3].includes(item.useChannel)){
                    desc = offlineJoinRangeTypeName[item.offlineJoinRangeType]
                }else if([0].includes(item.useChannel) && item.couponUseChannel.indexOf('3')>0){
                    desc = '线上-指定商场可用（全场商品可用）；线下-指定商场可用'
                }else{
                    if([1,2].includes(item.joinRangeType)){
                        let temp = item.joinRangeType+''+item.joinGoodsType+''
                        desc = joinGoodsName[temp]
                    }
                    else if([4].includes(item.joinRangeType)){
                        desc = joinRangeTypeName[item.joinRangeType]
                    }
                    else if([7].includes(item.joinRangeType)){
                        desc = joinSeckillGoodsTypeName[item.joinSeckillGoodsType]
                    }
                }
            }
            return desc;
        }
        function normalizeUseChannelName(item){
            let dec = '';
            if(item.couponType == 1){
                if(item.useChannel == 0){
                    let temp = item.useChannel+'' +item.couponUseChannel;
                    dec = useChannelName[temp];
                }else{
                    dec = useChannelName[item.useChannel];
                }
            }else{
                dec = ''
            }
            return dec
        }

        
        if(item){
          item.$limitask = normalizeLimitDesc(item);
          item.$useChannelName = normalizeUseChannelName(item);
        }
        // console.log(item)
        let str = data && data.couponMessage && 
        data.couponMessage.appSubOrderItemDetailVoList && 
        data.couponMessage.appSubOrderItemDetailVoList[0] && 
        data.couponMessage.appSubOrderItemDetailVoList[0].couponCodeVo && 
        data.couponMessage.appSubOrderItemDetailVoList[0].couponCodeVo.couponUseChannel || ''
        let temp = {...item, ...result}
        this.couponMessage =temp;
        this.couponItem = data.couponMessage.appSubOrderItemDetailVoList[0].couponCodeVo,
        this.couponUseChannel= str && (str.indexOf('3')>-1?true:false) || false;
        
      }
      if(data.a){
        this.isUser =true
      }
      
    },
    onToggleExplainClick() {
      this.boxButton = !this.boxButton;
    },
    onJumpExchange(couponId){
      this.$router.push({ name: "userCouponInfo", query: { id: couponId } })
    },
    onVirtualRefundBtn(t){
      this.$emit('initiateRefund',t, t)
    },
    onJumpToQrCodeDetail(couponId){
      this.$router.push({ name: "qrCouponInfo", query: { id: couponId } })
    },
    goPage(){
      this.$refs.copons.jumpToCouponList(this.couponItem)
    }
  },
  components:{copons}
};
</script>
<style lang="less"scoped>
.index-index-prefer {
  font-size: 24px;
  background: #ffffff;
}

.index-prefer-header {
  height: 114px;
  line-height: 114px;
  position: relative;
  font-size: 32px;
  text-align: center;
  background-color: #fff;
}
.index-prefer-list{
  padding: 0px 24px 0px 24px;
}
.index-prefer-header text {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #3B3A38;
}

.index-prefer-header .close {
  width: 48px;
  height: 48px;
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
}

.coupon {
  position: relative;
  font-size: 28px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-shadow: 0px 2px 8px 0px rgba(216,220,230,0.5);
  // padding-bottom: 16px;
  margin-top: -20px;
}
.coupon1{
  background-image: url('https://img.chinabeego.com/uploadfile/2023/5/16/16842033000811938326715587852.png');
}
.coupon2{
  background-image: url('https://img.chinabeego.com/uploadfile/2023/5/16/16842033696621937845245004861.png');
}
.coupon3{
  background-image: url('https://img.chinabeego.com/uploadfile/2023/5/16/16842034131131938439748114736.png');
}

.coupon:first-child {
  margin-top: 0;
}
.coupon .top .wei{
  display: flex;
  // padding-bottom: 120px;
  padding-bottom: 70px;
}
.coupon .top .wei .lef{
  width: 800px;
  padding: 24px;
  position: relative;
}
.coupon .top .wei .lef .sha{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 34px;
  margin-bottom: 24px;
  /* position: absolute;
  top: 0;
  margin-top: 24px; */
}
.coupon .top .wei .lef .sha .s1{
  width: 88px;
  height: 34px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #FFFFFF;
  font-size: 20px;
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 2px;
  padding-bottom: 2px;
  margin-right: 12px;
}
.coupon .top .wei .lef .sha .iconurl1{
  background-image: url('https://img.chinabeego.com/uploadfile/2023/5/16/16842035359261765128863018327.png');
}
.coupon .top .wei .lef .sha .iconurl2{
  background-image: url('https://img.chinabeego.com/uploadfile/2023/5/16/16842035699311939176619155045.png');
}
.coupon .top .wei .lef .sha .iconurl3{
  background-image: url('https://img.chinabeego.com/uploadfile/2023/5/16/16842035963741938623009215807.png');
}
.coupon .top .wei .lef .sha .s2{
  font-size: 26px;
  font-weight: 500;
  color: #3B3A38;
}
.coupon .top .wei .lef .zhon{
  width: 400px;
  font-size: 20px;
  font-weight: 400;
  color: #B4B4B4;
  line-height: 28px;
  margin-bottom: 74px;
  min-height: 28px;
}
.coupon .top .wei .lef .btom{
  position: absolute;
  // bottom: 0;
  /* margin-bottom: 24px; */
}
.coupon .top .wei .lef .xzhon{
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #F08E3C;
  line-height: 28px;
}
.coupon .top .wei .lef .szhon{
  font-size: 22px;
  color: #B4B4B4;
  line-height: 30px;
  margin-bottom: 16px;
  margin-top: 16px;
}
.coupon .top .wei .lef .xia{
  font-size: 20px;
  font-weight: 400;
  color: #62615F;
  line-height: 28px;
  display: flex;
  justify-content:start;
}
.coupon .top .wei .lef .xia .text1{
  /* width: 130px; */
}
.coupon .top .wei .lef .xia .text2{
  /* width: 100%; */
  flex: 1;
  margin-right: 24px;
}


.coupon .top .wei .rig{
  // height: 100%;
  width: 70%;
  vertical-align: middle;
  padding-bottom: 5px;
  // display: flex;
  // justify-content: center;
  // padding-top: 40px;
}
.coupon .top .wei .rig .sha{
  position: relative;
  min-height: 36px;
  display: flex;
  justify-content: end;
}
.coupon .top .wei .rig .shatd{
  height: 20px;
  width: 100%;
}
.coupon .top .wei .rig .sha .inc{
  width: 82px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 16px;
  opacity: 0.9;
  text-align: center;
  line-height: 36px;
  font-size: 20px;
  font-weight: 400;
  position: absolute;
  right: 0;
  color: #E15554;
}

.coupon .top .wei .rig .jio{
  color: #E15554;
}
.coupon .top .wei .rig .jio2{
  color: #6DB0FE;
}
.coupon .top .wei .rig .xia{
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-bottom: 24px;
}
.coupon .top .wei .rig .xia .zhen{
  text-align: center;
}
.coupon .top .wei .rig .xia .zhen .zhon{
  height: 26px;
  font-size: 18px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 26px;
  border-radius: 4px;
  border: 1px solid #FFFFFF;
  margin-top: 1px;
  margin-bottom: 3px;
}
.coupon .top .wei .rig .xia .zhen .szhon{
  width: 64px;
  height: 26px;
  border-radius: 4px;
  border: 1px solid #FFFFFF;
  font-size: 18px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 26px;
  margin-top: 1px;
  margin-bottom: 3px;
}
.coupon .top .wei .rig .xia .zhen .div1{
  font-size: 64px;
  font-family: 'number-bold';
  color: #FFFFFF;
}
.rich-price .i {
  font-style: normal;
  font-size: 34px;
}
.rich-price .i:first-child {
  font-weight: bold;
}
.coupon .top .wei .rig .xia .zhen .div1 .min{
  height: 40px;
  font-size: 32px;
  font-weight: 500;
  line-height: 40px;
}
.coupon .top .wei .rig .xia .zhen .div2{
  font-size: 24px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 32px;
}
.coupon .top .wei .rig .xia .zhen .div3{
  width: 100%;
  margin-top: 12px;
  text-align: center;
  display: flex;
  justify-content: center;
}
.coupon .top .wei .rig .xia .zhen .div3 .btn{
  width: 186px;
  background: #FFFFFF;
  border-radius: 40px;
  height: 38px;
  line-height: 38px;
  color: #E15554;
  font-size: 22px;
}
.coupon .top .wei .rig .xia .zhen .div3 .imgqc{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.coupon .top .wei .rig .xia .zhen .div3 .btn2{
  width: 136px;
  height: 38px;
  background: #FFFFFF;
  border-radius: 40px;
  font-size: 22px;
  font-weight: 500;
  line-height: 38px;
  color: #E15554;
}
.bottom-count{
  display: flex;
  justify-content: space-between;
}
.bottom-count .count-left{
  width: 260px;
  height: 84px;
  font-size: 24px;
  font-weight: 400;
  color: #F08E3C;
  line-height: 36px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url('https://img.chinabeego.com/uploadfile/2023/5/22/16847193454022744811279025976.png');
  line-height: 84px;
  text-align: center;
}
.bottom-count .count-right{
  height: 84px;
  font-size: 24px;
  font-weight: 500;
  color: #3B3A38;
  line-height: 84px;
}
.bottom-one{
  width: 490px;
  height: 10px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);

border-radius: 0px 0px 10px 10px;
margin: 0 40px;
}
.bottom-two{
  width: 670px;
  height: 10px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
  border-radius: 0px 0px 10px 10px;
  margin: 0 60px;
  margin-bottom: 52px;
}
.bottom-kong{
  width: 100%;
  height: 52px;
}
.foot-time-bar {
    height: 86px;
    line-height: 86px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(216, 220, 230, 0.5);
    border-radius: 0px 0px 16px 16px;
    margin-top: -5px;
    z-index: 9;
    padding-left: 24px;
    font-size: 22px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #B4B4B4;
    position: relative;
}
.more-img{
    width: 724px;
    height: 54px;
    position: absolute;
    left: -11px;
    bottom:-25px;
    max-width: 150% !important;
}
</style>
